export const selectedSurveyLayers = (state = {}, action) => {
  switch (action.type) {
    case 'SHOW_SURVEY_LAYER': {
      return {
        ...state,
        [action.payload.survey.id]: action.payload.survey,
      };
    }
    case 'HIDE_SURVEY_LAYER': {
      const newState = { ...state };
      delete newState[action.payload.survey.id];
      return newState;
    }
    default:
      return state;
  }
};
